"use strict";

var reduce = require("./reduce.js");

var go1Sync = require("../.internal/go1Sync.js");

module.exports = go;

function go(..._) {
  return reduce(go1Sync, _);
}